import React from "react";
import { watchTime } from "../lib/wakeTimer";

// 오늘 날짜 키(toDateString) — 자정이 지나면 다른 렌더가 없어도 한 번 바뀐다.
// 렌더 때 날짜만 읽으면 화면을 그대로 둔 탭은 다음 날에도 옛 값을 쥐고 있다(등급 카드의 7일 안내 · 최근 변화 창 · 다음 결정일 · 129차 #5).
// 화면 여러 곳이 같이 써도 타이머는 하나(130차 #9). 기다리는 규칙(일찍 울림 · 잠든 기기)은 watchTime 한 곳(137차 #4)
let currentKey = null;
let stop = null;
const listeners = new Set();

// 다음에 확인할 시각 — 지금 날짜가 키와 다르면(자정이 지남 · 시계·시간대가 앞뒤로 바뀜) 바로, 같으면 지금 기준 다음 자정.
// 키 문자열을 다시 날짜로 읽지 않는다 — 시간대가 뒤로 바뀌면 키가 하루 앞서 한 번의 자정을 놓쳤고, 일부 웹뷰는 그 문자열을 못 읽는다(138차 #1·#5)
function nextTarget() {
  const now = new Date();
  if (now.toDateString() !== currentKey) return now.getTime();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
}

function reach() {
  const key = new Date().toDateString();
  if (key !== currentKey) {
    currentKey = key;
    listeners.forEach((fn) => fn());
  }
  return true;   // 다음 자정도 기다린다
}

function subscribe(fn) {
  listeners.add(fn);
  if (listeners.size === 1) {
    currentKey = new Date().toDateString();
    stop = watchTime(nextTarget, reach);
  }
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      if (stop) stop();
      stop = null;
      // 듣는 화면이 없으면 날짜를 잊는다 — 다음 날 처음 그리는 화면이 어제 날짜로 한 번 그려지지 않게(134차 #7)
      currentKey = null;
    }
  };
}

function getSnapshot() {
  return currentKey ?? new Date().toDateString();
}

const noSubscribe = () => () => {};

// enabled=false 면 타이머·창 이벤트를 걸지 않는다 — 그릴 것이 없는 화면(요약 없는 배지 등)이 자정 감시를 붙들지 않게(140차 #2)
export default function useTodayKey(enabled = true) {
  return React.useSyncExternalStore(enabled ? subscribe : noSubscribe, getSnapshot, getSnapshot);
}
